import { render, staticRenderFns } from "./userCfg.vue?vue&type=template&id=786f13d6&scoped=true&"
import script from "./userCfg.vue?vue&type=script&lang=js&"
export * from "./userCfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786f13d6",
  null
  
)

export default component.exports